/**
 * Bunny Shield API
 * Bunny.net API for Bunny Shield (WAF, DDoS, Rate Limiting, Bot Detection, Access Lists & API Guardian).

 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 0 = Off 1 = Low 2 = Medium 3 = High 4 = Challenge
 */
export type DDoSShieldSensitivity = 0 | 1 | 2 | 3 | 4;

export const DDoSShieldSensitivity = {
  Off: 0 as DDoSShieldSensitivity,
  Low: 1 as DDoSShieldSensitivity,
  Medium: 2 as DDoSShieldSensitivity,
  High: 3 as DDoSShieldSensitivity,
  Challenge: 4 as DDoSShieldSensitivity,
};
